import {FC, ImgHTMLAttributes, useRef} from 'react';

import {useLazyLoadedImage, useReadyToRender} from '../hooks';
import {useCachedImageWidth} from '../hooks';
import {ErrorImage, PlaceholderImage} from '../Placeholder';
import {buildCachedPDFUrl} from '../utils';
type CachedPDFProps = {
    page: number;
    src: string;
} & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'>;

const CachedPDFImage: FC<CachedPDFProps> = ({alt, page, src, ...props}) => {
    const imageReference = useRef<HTMLImageElement>(null);
    const width = useCachedImageWidth(imageReference);
    const url = buildCachedPDFUrl(src, page, width);
    const shouldRender = useReadyToRender(imageReference, {key: url, page});
    const {data, error, isLoading} = useLazyLoadedImage(url, shouldRender);
    if (isLoading)
        return <PlaceholderImage data-page={page} ref={imageReference} />;
    if (error) return <ErrorImage data-page={page} ref={imageReference} />;

    return (
        <img
            className="pointer-events-none select-none rounded bg-white"
            data-page={page}
            ref={imageReference}
            src={data}
            {...props}
            alt={alt}
        />
    );
};

export default CachedPDFImage;
